import { render, staticRenderFns } from "./ReportCustomer2.vue?vue&type=template&id=5796f732&scoped=true"
import script from "./ReportCustomer2.vue?vue&type=script&lang=js"
export * from "./ReportCustomer2.vue?vue&type=script&lang=js"
import style0 from "./ReportCustomer2.vue?vue&type=style&index=0&id=5796f732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5796f732",
  null
  
)

export default component.exports